import { useEffect, useRef, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Clock, X } from 'lucide-react';

const DEADLINE_KEY = 'mtm_offer_deadline';
const WINDOW_MS = 24 * 60 * 60 * 1000; // rolling 24h per visitor

const getDeadline = () => {
  const now = Date.now();
  const stored = parseInt(localStorage.getItem(DEADLINE_KEY) || '0', 10);
  if (stored && stored > now) return stored;
  const next = now + WINDOW_MS;
  localStorage.setItem(DEADLINE_KEY, String(next));
  return next;
};

const two = (n) => String(n).padStart(2, '0');

export const CountdownOffer = ({ onClaim }) => {
  const [dismissed, setDismissed] = useState(false);
  const [remaining, setRemaining] = useState(0);
  const deadlineRef = useRef(0);

  useEffect(() => {
    deadlineRef.current = getDeadline();
    const tick = () => {
      let diff = deadlineRef.current - Date.now();
      if (diff <= 0) {
        // Roll the offer forward so the urgency never dead-ends at 00:00:00
        deadlineRef.current = Date.now() + WINDOW_MS;
        localStorage.setItem(DEADLINE_KEY, String(deadlineRef.current));
        diff = WINDOW_MS;
      }
      setRemaining(diff);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
    // Mount-only: sets up the countdown interval; helpers are module-stable.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (dismissed) return null;

  const totalSec = Math.floor(remaining / 1000);
  const hh = Math.floor(totalSec / 3600);
  const mm = Math.floor((totalSec % 3600) / 60);
  const ss = totalSec % 60;

  return (
    <div
      className="relative border-b border-amber-400/30 bg-gradient-to-r from-black/60 via-amber-500/5 to-black/60 backdrop-blur-sm"
      data-testid="countdown-offer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5">
        <div className="flex items-center justify-center gap-x-3 gap-y-1 flex-wrap text-center">
          <span className="flex items-center gap-1.5 text-amber-300 text-sm font-bold uppercase tracking-wide">
            <Clock className="w-4 h-4" /> Launch Offer
          </span>
          <span className="text-green-300 text-sm">
            Pro at <span className="text-green-400 font-bold">$19</span> ends in
          </span>
          <span
            className="font-mono text-base font-bold text-amber-300 tabular-nums bg-black/50 border border-amber-400/40 rounded px-2 py-0.5"
            data-testid="countdown-timer"
            aria-live="off"
          >
            {two(hh)}:{two(mm)}:{two(ss)}
          </span>
          <Button
            onClick={onClaim}
            className="btn-primary text-xs px-4 py-1.5 h-auto"
            data-testid="countdown-claim-btn"
          >
            Claim Offer
          </Button>
        </div>
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="absolute top-1/2 right-3 -translate-y-1/2 text-green-500/50 hover:text-green-300 transition-colors"
        aria-label="Dismiss offer"
        data-testid="countdown-dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
